import type { IconDefinition } from '../../types'

export default {
  details: [512, 512, [], '', 'M504 416H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM182.45 236.29c6.26 6.2 16.35 6.18 22.57-.05l84.63-84.63 82.22 82.22-44.71 44.71c-15.3 15.3-4.46 41.46 17.17 41.46H463.8c8.94 0 16.19-7.25 16.19-16.19V184.34c0-14.64-11.98-24.34-24.46-24.34-5.97 0-12.05 2.21-17 7.16L394.5 211.2l-93.53-93.53c-6.25-6.25-16.38-6.25-22.63 0l-84.69 84.69-72.69-72.01c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l84.11 83.32zM448 202.96V288h-85.04L448 202.96z'],
  name: 'uiChartLineDown',
  oldName: 'falChartLineDown'
} as IconDefinition
